interface HotspotI<T, K> {
  name: T;
  params: K;
}

export enum Hotspots {
  OfferPromoteJobBoards = 'offer.promote.job_boards',
  OfferPipelineBadges = 'offer.pipeline.badges',
  OfferTabs = 'offer.tabs',
  OfferTabContent = 'offer.tab_content',
  SettingsIntegrationsPage = 'settings.integrations_page',
  SettingsIntegrationsItemBadges = 'settings.integrations_item_badges',
  CandidateProfileOverview = 'candidate_profile.overview',
  CandidateProfileMore = 'candidate_profile.more',
  CandidateProfileBadges = 'candidate_profile.badges',
  CandidateProfileTabs = 'candidate_profile.tabs',
  CandidateProfileTabContent = 'candidate_profile.tab_content',
  CandidatesTableBadges = 'candidates_table.badges',
  CompanyTeamMembersAdd = 'company.team_members.add',
  SidebarButton = 'sidebar.button',
  FullPage = 'full_page',
  Debug = 'debug',
}

export type OfferPromoteJobBoardsHotspot = HotspotI<
  Hotspots.OfferPromoteJobBoards,
  { offerId: number; location?: string }
>;
export type OfferTabsHotspot = HotspotI<Hotspots.OfferTabs, { offerId: number }>;
export type OfferTabContentHotspot = HotspotI<Hotspots.OfferTabContent, { offerId: number }>;
export type OfferPipelineBadgesHotspot = HotspotI<
  Hotspots.OfferPipelineBadges,
  { candidateId: number }
>;
export type SettingsIntegrationsPageHotspot = HotspotI<Hotspots.SettingsIntegrationsPage, {}>;
export type SettingsIntegrationsItemBadges = HotspotI<Hotspots.SettingsIntegrationsItemBadges, {}>;
export type CandidateProfileOverviewHotspot = HotspotI<
  Hotspots.CandidateProfileOverview,
  { candidateId: number; offerId?: number }
>;
export type CandidateProfileMoreHotspot = HotspotI<
  Hotspots.CandidateProfileMore,
  { candidateId: number; offerId?: number }
>;
export type CandidateProfileBadgesHotspot = HotspotI<
  Hotspots.CandidateProfileBadges,
  { candidateId: number }
>;
export type CandidateProfileTabsHotspot = HotspotI<
  Hotspots.CandidateProfileTabs,
  { candidateId: number }
>;
export type CandidateProfileTabContentHotspot = HotspotI<
  Hotspots.CandidateProfileTabContent,
  { candidateId: number }
>;
export type CandidatesTableBadgesHotspot = HotspotI<
  Hotspots.CandidatesTableBadges,
  { candidateId: number }
>;

export type CompanyTeamMembersAddHotspot = HotspotI<Hotspots.CompanyTeamMembersAdd, {}>;

export type SidebarButtonHotspot = HotspotI<Hotspots.SidebarButton, {}>;

export type FullPageHotspot = HotspotI<Hotspots.FullPage, { codename: string }>;

export type DebugHotspot = HotspotI<Hotspots.Debug, {}>;

export type Hotspot =
  | OfferPromoteJobBoardsHotspot
  | OfferPipelineBadgesHotspot
  | OfferTabsHotspot
  | OfferTabContentHotspot
  | SettingsIntegrationsPageHotspot
  | SettingsIntegrationsItemBadges
  | CandidateProfileOverviewHotspot
  | CandidateProfileMoreHotspot
  | CandidateProfileBadgesHotspot
  | CandidateProfileTabsHotspot
  | CandidateProfileTabContentHotspot
  | CandidatesTableBadgesHotspot
  | CompanyTeamMembersAddHotspot
  | SidebarButtonHotspot
  | FullPageHotspot
  | DebugHotspot;
